<template>
    <div class="container">
        <!-- Banner -->
        <div class="swiper-container home-banner">
            <div class="swiper-wrapper">
                <div class="swiper-slide" @click="clickBannerPath()"><img class="img" :src="banner[0]" /></div>
                <div class="swiper-slide" @click="clickBannerPath()"><img class="img" :src="banner[1]" /></div>
            </div>
            <div class="swiper-pagination"></div>
            <div class="swiper-button-next"></div>
            <div class="swiper-button-prev"></div>
        </div>
        <!-- 服务范围 -->
        <div class="container-main padding40-0 lazy-load-container" v-if="service"
            v-observe-visibility="(isVisiblefun, entryfun) => visibilityChanged(isVisiblefun, entryfun, 0)"
            :options="{ threshold: 0.9 }">
            <div v-if="isVisible0">
                <div class="text-center padding-bottom40">
                    <div class="colorsuccess font-size-24 animate-element-down">服务范围</div>
                    <div class="color6c757d margin-top5 animate-element-up">- ------SERVICE------ -</div>
                </div>
                <div class="flex _flex">
                    <div class="margin0-15 border width251 _width251 cursor padding-bottom15 animate-element"
                        v-for="(item, index) in service" :key="index" @click="clickInfo(item, 'serviceinfo')">
                        <div class="padding0-15">
                            <div class="padding40-0">
                                <img class="service-img" :src="item.image" width="80" height="80" />
                            </div>
                            <div class="multi-line-ellipsis font-size-18 text-left href-color">{{ item.name }}</div>
                            <div class="multi-line-ellipsis multi-line-ellipsis-4 margin-top10 font-size-14 text-left">
                                {{
                                    item.desc }}</div>
                        </div>
                    </div>
                </div>
                <div class="more margin-top40 animate-element-down" @click="clickList('service',5)">查看更多</div>
            </div>
        </div>
        <!-- 实验室EPC -->
        <div class="epc padding40-0 lazy-load-container"
            v-observe-visibility="(isVisiblefun, entryfun) => visibilityChanged(isVisiblefun, entryfun, 1)"
            :options="{ threshold: 0.9 }">
            <div class="container-main" v-if="epc && isVisible1">
                <div class="text-center padding-bottom40">
                    <div class="colorsuccess font-size-24 animate-element-down">实验室EPC（总承包）</div>
                    <div class="color6c757d margin-top5 animate-element-up">- ------LABORATORY EPC------ -</div>
                </div>
                <div class="flex _flex">
                    <div class="margin0-15 border bgWhite cursor animate-element _width251" :class="{flex1:$global.isPc}" v-for="(item, index) in epc"
                        :key="index" @click="clickInfo(item, 'epcinfo')">
                        <div class=" overflow">
                            <img :src="item.image" width="100%" />
                        </div>
                        <div class="multi-line-ellipsis font-size-18 text-left margin20-0 padding-left15 href-color">{{
                            item.name
                        }}</div>
                    </div>
                </div>
                <div class="more margin-top40 colorddd animate-element-down" @click="clickList('epc',1)">查看更多</div>
            </div>
        </div>
        <!-- 工程案例 -->
        <div class="container-main padding40-0 lazy-load-container" v-if="casec"
            v-observe-visibility="(isVisiblefun, entryfun) => visibilityChanged(isVisiblefun, entryfun, 2)"
            :options="{ threshold: 0.9 }">
            <div v-if="isVisible2">
                <div class="text-center padding-bottom40">
                    <div class="colorsuccess font-size-24 animate-element-down">工程案例</div>
                    <div class="color6c757d margin-top5 animate-element-up">- 服务创造价值、存在造就未来 -</div>
                </div>
                <div class="flex _flex width1001 flexwrap">
                    <div class="margin415 border width251-4 cursor animate-element _width251" v-for="(item, index) in casec"
                        :key="index" @click="clickInfo(item, 'caseinfo')">
                        <div class="overflow">
                            <img :src="item.image" width="100%" />
                        </div>
                        <div class="multi-line-ellipsis font-size-18 text-left margin20-0 padding-left15 href-color">{{ item.name
                            }}</div>
                    </div>
                </div>
                <div class="more margin-top40 animate-element-down" @click="clickList('case',8)">查看更多</div>
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import Swiper from 'swiper'
import "swiper/dist/css/swiper.css";
export default {
    name: 'home',
    data() {
        return {
            banner: [require('../assets/banner01.jpg'), require('../assets/banner02.jpg')],
            service: [],
            epc: [],
            casec: [],
            isVisible0: false,
            isVisible1: false,
            isVisible2: false,
            isfirst0: true,
            isfirst1: true,
            isfirst2: true,
            isScrollTop: false
        }
    },
    created() {
        this.$nextTick(() => {
            //在窗口滚动时调用监听窗口滚动方法
            window.addEventListener('scroll', this.windowScrollListener, true);
            this.init()
            this.getSwiper()
        })
    },
    mounted() {
    },
    methods: {
        windowScrollListener() {
            // this.scrollTop = Math.floor(document.documentElement.scrollTop || document.body.scrollTop || document.querySelector('#app').scrollTop)
            this.isScrollTop = true
        },
        visibilityChanged(isVisible, entry, n) {
            if (!this.isScrollTop) {
                if (this[`isfirst${n}`] && isVisible) {
                    this[`isfirst${n}`] = false
                    console.log(isVisible, n, 'isfirst')
                    return
                }
            }
            // console.log(isVisible, n, 'visibilityChanged')
            if (isVisible && typeof n == 'number') {
                this[`isVisible${n}`] = isVisible
            }
        },
        init() {
            let that = this
            this.$http.get('/api/index/index').then(
                res => {
                    // console.log(res, '返回结果')
                    that.service = res.data.data.service
                    that.epc = res.data.data.epc
                    that.casec = res.data.data.case
                },
                error => { }
            )
        },
        clickInfo(item, path) {
            this.$router.push({ name: path, query: { id: item.id } })
        },
        clickList(path,scode) {
            this.$router.push({ name: path ,query:{scode:scode}})
        },
        clickBannerPath() {
            location.href = 'https://yinaixinxi.com/'
        },
        getSwiper() {
            this.swiper = new Swiper(".swiper-container", {
                loop: true, // 无缝
                // autoplay: 5000,
                disableOnInteraction: false, //*手动操作轮播图后不会暂停*
                // paginationClickable: true,
                slidesPerView: 1, // 一组三个
                // 如果需要前进后退按钮
                nextButton: '.swiper-button-next',
                prevButton: '.swiper-button-prev',
                // 窗口变化,重新init,针对F11全屏和放大缩小,必须加
                observer: true,
                //设为true开启图片延迟加载
                lazyLoading: true,
                //当过渡到slide后开始加载图片
                lazyLoadingOnTransitionStart: true,
                observeParents: true,
                // 如果需要分页器
                pagination: '.swiper-pagination',
                preventDefault: false
            })
        }
    }
}
</script>
<style scoped>
.epc {
    background-image: url(../assets/epcbg.jpg);
    background-repeat: no-repeat;
    background-size: cover;
}

.lazy-load-container {
    min-height: 100px;
}
</style>
